import script from "./MakeModelSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./MakeModelSearch.vue?vue&type=script&setup=true&lang=ts"

import "./MakeModelSearch.vue?vue&type=style&index=0&id=a73b419a&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a73b419a"]])

export default __exports__